import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { FeatureFlagContractService } from "./feature-flag.contract.service";
import { HttpClient } from "@angular/common/http";
import { ElectronService } from "../../electron.service";
import { Observable } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { FeatureFlag } from "../../_objects/feature-flag";
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagOnlineService extends HttpService implements FeatureFlagContractService {
  private featureFlags: FeatureFlag[] = [];

  constructor(
    private http: HttpClient,
    private router: Router,
    private electronService: ElectronService,
    private cookieService: CookieService) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }
    isFlagEnabled(flagName: string): boolean {
        return this.featureFlags.filter(flag => flag.name === flagName && flag.isEnabled).length > 0;
    }

  getFeatureFlags(): Observable<FeatureFlag[]> {
    const endpoint = super.getEndpoint('featureflags');
      return this.http.get<FeatureFlag[]>(endpoint,
        { withCredentials: super.getWithCredentialsOption() });
  }

  public fetchAndUpdate() {
    this.getFeatureFlags()
      .subscribe(flags => this.featureFlags = flags);
  }

}
